
import { Input } from "element-ui"

import { showGlobalMessage, openNoAddressPop, formatWareImgUrl } from "@/utils/utils"
import { handleModifyCartV2 } from "@/utils/cartResponse"
import emptyImg from "@/assets/images/empty_img.png"
import lazyImg from "@/components/cms/lazyImg.vue"
export default {
  name: "SpuAttributes",
  components: {
    [Input.name]: Input,
    lazyImg
  },

  props: {
    // 接受的是从后端接口请求到的商品详情（sku列表）
    goodsInfo: {
      type: Object,
      default: () => {},
      require: true
    },
    // 接受的是商品列表传入信息
    goodsChange: {
      type: Object,
      default: () => {},
      require: true
    }
  },
  data() {
    return {
      selectSku: {}, // 接受的是接口详情选中的sku对象
      goodsObject: {} // 接受的是商品信息对象
    }
  },

  watch: {
    goodsChange: {
      handler(newVal) {
        this.goodsObject = newVal
      },
      immediate: true
    },
    goodsInfo: {
      handler(newVal) {
        if (JSON.stringify(this.goodsObject === "{}")) {
          this.goodsObject = {
            additional: {
              spuId: ""
            }
          }
          newVal.spuAttributes.forEach(item => {
            // 默认选中第一项或指定的defaultSelected项
            // const defaultItem = attrValues.find(item => item.selected)
            item.attrValues.forEach(val => {
              if (val.selected) {
                this.$set(this.selectSku, item.attrCode, val.attrValueId)
              }
            })
          })
          this.goodsObject.additional.spuId = newVal.spuId
        }
      },
      immediate: true
    }
  },

  methods: {
    imageUrl(url) {
      if (url) {
        return formatWareImgUrl(url)
      }
      return emptyImg
    },
    attrStatusName(status) {
      // 0-正常，1-售罄，2-下架,9-黑名单,5-商品不存在，-1 CommingSoon， 10-异常，但不展示文案
      switch (status) {
        case 0:
          return this.$t("sku.normal")
        case 1:
          return this.$t("sku.soldOut")
        case 2:
          return this.$t("sku.takeDown")
        case 9:
          return this.$t("sku.blacklist")
        case 5:
          return this.$t("sku.noProduct")
        case -1:
          return this.$t("sku.commingSoon")
        case 10:
          return this.$t("sku.abnormal")
        default:
          break
      }
    },
    // 动态控制内联样式
    styleChange(item) {
      const obj = {}
      obj.padding = item.attrImageUrl ? "0.04rem 0.08rem 0.04rem 0.04rem" : "0.08rem"
      obj.justifyContent = !item.attrImageUrl ? "center" : "space-between"
      // 0-正常， 1-售罄，2-下架,9-黑名单,5-商品不存在，-1 CommingSoon， 10-异常，但不展示文案
      if (item.attrStatus === 0) {
        obj.color = "#000"
      } else {
        obj.color = "#C4C4C4"
      }
      return obj
    },
    // 点击改变选中的颜色
    attrChang(val, item) {
      this.goodsInfo.spuAttributes.forEach(v => {
        if (v.attrId === val.attrId) {
          v.attrValues.forEach(i => {
            i.selected = i.attrValueId === item.attrValueId
          })
        }
      })
      // 提取多规sku数据
      this.selectSku[val.attrCode] = item.attrValueId
      // 获取多规格匹配Id
      const sku = this.findSkuIdByAttributes(this.goodsInfo.wareList, this.selectSku)
      // 根据最新的SKU请求商品详情
      if (sku) {
        console.log(sku, "skuskuskusku")
        this.$emit("fetchClick", { additional: this.goodsObject.additional, sku })
      } else {
        // 获取没有sku数据的情况
        const arr = []
        this.goodsInfo.spuAttributes.forEach(val => {
          val.attrValues.forEach(item => {
            if (item.selected) {
              arr.push({ ...item, attrId: val.attrId })
            }
          })
        })
        const skuObj = {
          skuId: "",
          spuAttributeInfos: arr
        }
        console.log({ additional: this.goodsObject.additional, sku: skuObj }, "2342")

        this.$emit("fetchClick", { additional: this.goodsObject.additional, sku: skuObj })
      }
    },
    // sku匹配计算
    findSkuIdByAttributes(skuList, targetAttributes) {
      for (const sku of skuList) {
        // 将 spuAttibuteInfos 转换为 { attrCode: attrValueCode } 的键值对
        const attributes = sku.spuAttributeInfos.reduce((acc, attr) => {
          acc[attr.attrCode] = attr.attrValueId // 也可用 attrValueName/attrValueCode
          return acc
        }, {})
        // 检查是否所有目标属性都匹配
        const isMatch = Object.entries(targetAttributes).every(([key, value]) => attributes[key] === value)

        if (isMatch) {
          return sku
        }
      }
      return null // 未找到匹配项
    }
  }
}
